import React from 'react';
import Header from '../Header';

import {GP_URL, AP_URL} from '../config';

import GooglePlay from '../../assets/images/google_play.png';
import AppStore from '../../assets/images/appstore.png';

import './hero.scss';

const Hero = () => {
    return (
        <section className="hero">
            <div className="container">
                <div className="hero__left">
                    <Header />
                    <h1 className="hero__title" data-aos="fade-up">Graj <br/>na zdrowie <br/>z <strong>MukoApp</strong></h1>
                    <p className="hero__desc" data-aos="fade-up" data-aos-delay="200">Unikatowy system motywujący pomoże Ci zaplanować dzień tak, aby znalazł się czas na wszystko. Wykonuj ćwiczenia, zdobywaj odznaki jednocześnie czuwając nad stanem swojego zdrowia.</p>
                    <a href={AP_URL} rel="noreferrer" target="_blank" className="appstore"><img src={AppStore} alt="Pobierz z App Store" data-aos="fade-up" data-aos-delay="350"/></a>
                    <a href={GP_URL} rel="noreferrer" target="_blank" className="googleplay"><img src={GooglePlay} alt="Pobierz z Google Play" data-aos="fade-up" data-aos-delay="300"/></a>
                </div>
                <div className="hero__image"  data-aos="fade-left" />
            </div>
        </section>
    )
}

export default Hero;